const getWatchedFields = watch => ({
  companyType: watch('company_type'),
  customer: watch('customer'),
  businessType: watch('customer.business_type'),
  accountCashOnly: watch('account_cash_only'),
  companyNumberSearched: watch('companyNumberSearched'),
  companyNumberLookupSuccess: watch('companyNumberLookupSuccess'),
  companyNumber: watch('company_number'),
  companyName: watch('company_name'),
  companyVatNumber: watch('company_vat_number'),
  addressOne: watch('addresses.1'),
  addressTwo: watch('addresses.2'),
  billingAddressMatchesRegistered: watch('billingAddressMatchesRegistered'),
  ownProperty: watch('addresses.1.own'),
  propertyDuration: watch('addresses.1.more_than_3_years'),
  accountContactName: watch('account_contact_name'),
  accountContactEmail: watch('account_contact_email'),
  accountContactPhone: watch('account_contact_telephone'),
  purchasingContactName: watch('purchasing_contact_name'),
  purchasingContactEmail: watch('purchasing_contact_email'),
  purchasingContactPhone: watch('purchasing_contact_telephone'),
  dateOfBirth: watch('date_of_birth'),
});

export default getWatchedFields;
